import { faPlaneDeparture } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { Component } from "react";
import { connect } from "react-redux";
import { Row, Col, Button, Form } from "react-bootstrap";
import { ExchangeIntialRequest } from "../../model/exchange/ExchangeIntialRequest";
import HttpService from "../../service/shared/HttpService";
import "./Exchange.css";
import Loading from "../booking/seat-selection/Loading";
import moment from "moment";
import Translation from "i18next";
import { AirportFullName } from "../../service/shared/AirportFullName";
import ExchangeFlightDetail from "./ExchangeFlightDetail";
import { exchangeAction } from "../../redux/actions/exchange/exchangeAction";
import ItineraryPart from "../../model/itineraryPart/ItineraryPart";
import SearchRequest from "../../model/API/SearchRequest";
import { searchFlightAction } from "../../redux/actions/booking/searchFlightAction";
import { Redirect } from "react-router";
import { ExchangeFlightSearchRequest } from "../../model/exchange/ExchangeFlightSearchRequest";
import Passenger from "../../model/passenger/passenger";
import Exception from "../shared/exception/Exception";
class Exchange extends Component {
  constructor(props) {
    super(props);
    this.state = {
      apiResponse: null,
      passengers: [],
      itineraryParts: [],
      isLoading: false,
      isRedirectToWidget: false,
      selectedFlights: [],
      hasException: false,
      statusCode: null,
    };
  }
  componentDidMount() {
    let exchangeIntailRequest = new ExchangeIntialRequest();
    exchangeIntailRequest.requestObject.PNR =
      this.props.location.state.request.PNR;
    exchangeIntailRequest.requestObject.lastName =
      this.props.location.state.request.lastName;
    let relativePath = "/etibe-exchangeapi/V1.0/Availability/Initialize";
    let token = this.props.searchFlight.token;
    this.setState({ isLoading: true });
    HttpService.postServiceExchange(
      exchangeIntailRequest.requestObject,
      relativePath,
      token
    )
      .then((response) => {
        
        if (response.data.statusAPI === "SUCCESS") {
          this.props.updateOriginalPayment(
            response.data.payments[0].price.alternatives[0][0]
          );
          this.setState({
            isLoading: false,
            apiResponse: response.data,
            passengers: response.data.passengers,
            itineraryParts: response.data.itinerary.itineraryParts,
          });
        } else {
          this.setState({
            isLoading: false,
            hasException: true,
            statusCode: response.status,
          });
        }
      })
      .catch((error) => {
        
        console.log(JSON.stringify(error));
        this.setState({
          isLoading: false,
          hasException: true,
          statusCode: error.status,
        });
      });
  }
  renderStops(segments, stops) {
    if (stops > 0) {
      if (segments.length > 1) {
        return (
          <span>
            <span>
              {stops > 1
                ? stops + " " + Translation.t("stops")
                : stops + " " + Translation.t("stop")}
            </span>
          </span>
        );
      } else {
        return (
          <span>
            <span>
              {stops > 1
                ? stops + " " + Translation.t("stops")
                : stops + " " + Translation.t("stop")}
            </span>
            {segments.map((segment, index) => (
              <span key={index}>
                {segment.flight.stopAirports.map((airport, index2) => (
                  <span key={index2}>{" " + airport.airport}</span>
                ))}
              </span>
            ))}
          </span>
        );
      }
    } else {
      return <span>{Translation.t("non-stop")}</span>;
    }
  }
  parseTime = (minute) => {
    let hours = parseInt(minute / 60);
    let minutes = minute % 60;
    return <span>{hours + "hrs " + minutes + " mins"}</span>;
  };
  parseDate = (dateString) => {
    let time = moment(dateString)
      .locale(localStorage.getItem("i18nextLng"))
      .format("LT");

    let newDate = moment(dateString)
      .locale(localStorage.getItem("i18nextLng"))
      .format("DD MMMM YYYY");
    return (
      <span>
        {newDate} {time}{" "}
      </span>
    );
  };
  renderPassengerType = (type) => {
    switch (type) {
      case "ADT":
        return "ADULT";
      case "CHD":
        return "CHILD";
      case "INF":
        return "INFANT";
      default:
        return "";
    }
  };
  onFlightChecked = (index) => {
    
    let selectedFlights = this.state.selectedFlights;
    if (selectedFlights.includes(index)) {
      selectedFlights.splice(selectedFlights.indexOf(index), 1);
    } else {
      selectedFlights.push(index);
    }
    this.setState({ selectedFlights });
  };
  onContinueClicked = () => {
    
    let isRoundTrip = false;
    this.props.updatePassenger(this.state.passengers);
    
    let exchangeFlightsearchRequest = new ExchangeFlightSearchRequest();
    let itineraryPart = new ItineraryPart();

    let passenger = new Passenger();
    let adult = 0,
      child = 0,
      infant = 0;
    this.state.passengers.forEach((passenger) => {
      if (passenger.passengerInfo.type === "ADT") {
        adult++;
      }
      if (passenger.passengerInfo.type === "CHD") {
        child++;
      }
      if (passenger.passengerInfo.type === "INF") {
        infant++;
      }
    });
    passenger.adult = adult;
    passenger.child = child;
    passenger.infant = infant;
    exchangeFlightsearchRequest.flightRequest.passengerInfo = passenger;

    if (
      this.state.itineraryParts.length > 1 &&
      this.state.selectedFlights.length > 1
    ) {
      itineraryPart.params.from = {
        value: this.state.itineraryParts[0].segments[0].origin,
        label: AirportFullName.getFullName(
          this.state.itineraryParts[0].segments[0].origin
        ),
      };
      itineraryPart.params.to = {
        value:
          this.state.itineraryParts[0].segments[
            this.state.itineraryParts[0].segments.length - 1
          ].destination,
        label: AirportFullName.getFullName(
          this.state.itineraryParts[0].segments[
            this.state.itineraryParts[0].segments.length - 1
          ].destination
        ),
      };

      exchangeFlightsearchRequest.flightRequest.journyType = "roundTrip";
      itineraryPart.params.when.departureDate = moment(
        this.state.itineraryParts[0].segments[0].departure
      ).format("YYYY-MM-DD");
      itineraryPart.params.when.arrivalDate = moment(
        this.state.itineraryParts[1].segments[0].departure
      ).format("YYYY-MM-DD");
      isRoundTrip = true;
    } else {
      if (this.state.itineraryParts.length > 1) {
        exchangeFlightsearchRequest.flightRequest.journyType = "oneWay";

        itineraryPart.params.from = {
          value:
            this.state.itineraryParts[this.state.selectedFlights[0]].segments[0]
              .origin,
          label: AirportFullName.getFullName(
            this.state.itineraryParts[this.state.selectedFlights[0]].segments[0]
              .origin
          ),
        };
        itineraryPart.params.to = {
          value:
            this.state.itineraryParts[this.state.selectedFlights[0]].segments[
              this.state.itineraryParts[this.state.selectedFlights[0]].segments
                .length - 1
            ].destination,
          label: AirportFullName.getFullName(
            this.state.itineraryParts[this.state.selectedFlights[0]].segments[
              this.state.itineraryParts[this.state.selectedFlights[0]].segments
                .length - 1
            ].destination
          ),
        };
        if (this.state.selectedFlights[0] === 0) {
          itineraryPart.params.when.departureDate = moment(
            this.state.itineraryParts[this.state.selectedFlights[0]].segments[0]
              .departure
          ).format("YYYY-MM-DD");
          itineraryPart.params.when.arrivalDate = null;
        } else {
          itineraryPart.params.when.departureDate = moment(
            this.state.itineraryParts[this.state.selectedFlights[0]].segments[0]
              .departure
          ).format("YYYY-MM-DD");
          itineraryPart.params.when.arrivalDate = null;
        }
        isRoundTrip = false;
      } else {
        exchangeFlightsearchRequest.flightRequest.journyType = "oneWay";

        itineraryPart.params.from = {
          value: this.state.itineraryParts[0].segments[0].origin,
          label: AirportFullName.getFullName(
            this.state.itineraryParts[0].segments[0].origin
          ),
        };
        itineraryPart.params.to = {
          value:
            this.state.itineraryParts[0].segments[
              this.state.itineraryParts[0].segments.length - 1
            ].destination,
          label: AirportFullName.getFullName(
            this.state.itineraryParts[0].segments[
              this.state.itineraryParts[0].segments.length - 1
            ].destination
          ),
        };
        itineraryPart.params.when.departureDate = moment(
          this.state.itineraryParts[0].segments[0].departure
        ).format("YYYY-MM-DD");
        itineraryPart.params.when.arrivalDate = null;
        isRoundTrip = false;
      }
    }
    let exchangeType = "outbound";
    if (this.state.selectedFlights.length > 0) {
      if (this.state.selectedFlights.length > 1) {
        exchangeType = "both";
      } else {
        if (this.state.selectedFlights[0] === 0) {
          exchangeType = "outbound";
        } else {
          exchangeType = "inbound";
        }
      }
    }
    let flightExtraInfo = {
      cookieSabreDataRequest: this.state.apiResponse.cookieSabreDataRequest,
      isRoundTrip: isRoundTrip,
      exchangeType: exchangeType,
      arrivalMinDate:
        this.state.itineraryParts[0].segments[
          this.state.itineraryParts[0].segments.length - 1
        ].arrival,
      arrivalDate:
        this.state.itineraryParts.length > 1 && !isRoundTrip
          ? this.state.itineraryParts[1].segments[0].departure
          : null,
    };
    this.props.updateFlightExtraInfo(flightExtraInfo);
    exchangeFlightsearchRequest.flightRequest.itineraryPart.push(itineraryPart);

    this.props.updateItinerary(exchangeFlightsearchRequest.flightRequest);
    this.setState({ isRedirectToWidget: true });
  };
  render() {
    if (this.state.isRedirectToWidget) {
      return (
        <Redirect
          to={{
            pathname: "/exchange/widget",
          }}
        />
      );
    }
    if (this.state.hasException) {
      return <Exception statusCode={this.state.statusCode} />;
    }
    return (
      <section className="mt-4">
        {this.state.isLoading ? (
          <Loading />
        ) : (
          <div>
            <div className="container bg-white exchange-container">
              <h2 className="pb-3">Change Flight(S)</h2>
              <h3>Select the flight(s) you wish to change.</h3>
              <div>
                <span>
                  Prices are quoted per adult in the Reward Points and include
                  taxes and fees except for the Booking and Service Fee which is
                  charged per passenger per booking for payment by credit or
                  debit card. Fares exclude any local taxes that are payable at
                  the airport.
                </span>
              </div>
              <hr />
              <h3 className="pt-3">Passengers</h3>
              <div>
                <span>
                  The change will be for all passengers in the booking. Please
                  call customer service, +251 116 179 900 (International Charges
                  Apply), for additional questions.
                </span>
              </div>
              {this.state.passengers.map((passenger, key) => (
                <div className="pt-3" key={key}>
                  <h5>
                    <span className="passenger-counter">{key + 1}</span>{" "}
                    <span>{passenger.passengerDetails.firstName}</span>{" "}
                    <span>{passenger.passengerDetails.lastName}</span>{" "}
                    <span>
                      ({this.renderPassengerType(passenger.passengerInfo.type)})
                    </span>{" "}
                  </h5>
                </div>
              ))}

              <hr />
              <h2>FLIGHTS</h2>
              <br />
              {this.state.itineraryParts.map((itineraryPart, key) => (
                <div className="flight-info-container" key={key}>
                  <div>
                    {this.state.itineraryParts.length > 1 && (
                      <Form>
                        <Form.Check
                          className="d-inline-block"
                          onClick={() => this.onFlightChecked(key)}
                        ></Form.Check>
                        {key === 0 && <label> Your Departure Flight</label>}
                        {key === 1 && <label> Your Return Flight</label>}
                      </Form>
                    )}
                  </div>
                  <hr />
                  <div>
                    <span className="px-4 departure-icon">
                      <FontAwesomeIcon icon={faPlaneDeparture} />
                    </span>
                    <span className="city-name">
                      {AirportFullName.getFullName(
                        itineraryPart.segments[0].origin
                      )}
                    </span>
                    <span className="px-5"></span>
                    <span className="city-name">
                      {" "}
                      {AirportFullName.getFullName(
                        itineraryPart.segments[
                          itineraryPart.segments.length - 1
                        ].destination
                      )}
                    </span>
                    <span className="confirm-badge">Confirmed</span>
                  </div>
                  <hr />
                  <div className="py-3 flight-detail">
                    <Row>
                      <Col xs={12} sm={12} md={4} lg={3} className="pb-3">
                        <span className="display-ib">
                          {/* 29 MAY 2021 */}
                          {moment(itineraryPart.segments[0].departure)
                            .locale(localStorage.getItem("i18nextLng"))
                            .format("DD MMM  YYYY")}{" "}
                        </span>
                      </Col>
                      <Col xs={12} sm={12} md={8} lg={6}>
                        <div className="pb-3">
                          <span className="display-ib">
                            {/* 29 May 09:00  */}
                            {this.parseDate(
                              itineraryPart.segments[0].departure
                            )}
                            Departure{" "}
                            {AirportFullName.getFullName(
                              itineraryPart.segments[0].origin
                            )}
                          </span>
                        </div>
                        <div className="pb-3">
                          <span className="display-ib">
                            {this.parseDate(
                              itineraryPart.segments[
                                itineraryPart.segments.length - 1
                              ].arrival
                            )}{" "}
                            Arrive{" "}
                            {AirportFullName.getFullName(
                              itineraryPart.segments[
                                itineraryPart.segments.length - 1
                              ].destination
                            )}
                          </span>
                        </div>
                      </Col>
                      <Col xs={12} sm={12} md={12} lg={3} className="pb-3">
                        <span>{itineraryPart.bookingClass}</span>
                      </Col>
                    </Row>
                    <Row>
                      {itineraryPart.segments.map((segment) => (
                        <Col className="text-center">
                          {segment.flight.airlineCode === "ET" && (
                            <img
                              className="custom-img-sm-flag"
                              src="data:image/png;base64,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"
                            />
                          )}
                          <span className="pr-4 pl-1">
                            {segment.flight.airlineCode +
                              segment.flight.flightNumber}
                          </span>
                          <span>
                            {this.renderStops(
                              itineraryPart.segments,
                              itineraryPart.stops
                            )}
                          </span>
                          <span className="px-2">|</span>
                          <span>
                            {/* 5 hrs 25 mins{" "} */}
                            {this.parseTime(segment.duration)}
                          </span>
                        </Col>
                      ))}
                    </Row>
                    <br />
                    <Row>
                      <Col xs={12}>
                        <ExchangeFlightDetail
                          itineraryParts={this.state.itineraryParts}
                        />
                      </Col>
                    </Row>
                  </div>
                </div>
              ))}
            </div>
            <div className="container mt-4  text-right px-sm-3 px-md-0">
              <Button className="exchange-cancel-btn">CANCEL</Button>
              <span className="px-2"></span>
              {this.state.itineraryParts.length > 1 &&
                this.state.selectedFlights.length === 0 && (
                  <Button className="continue-btn" disabled>
                    CONTINUE
                  </Button>
                )}
              {(this.state.itineraryParts.length === 1 ||
                this.state.selectedFlights.length !== 0) && (
                <Button
                  className="continue-btn"
                  onClick={() => this.onContinueClicked()}
                >
                  CONTINUE
                </Button>
              )}
            </div>
          </div>
        )}
      </section>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    searchFlight: state.searchFlight,
    exchangePassengers: state.exchangePassengers,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    updatePassenger: (passengers) => {
      dispatch({
        type: exchangeAction.SAVEPASSENGER,
        value: passengers,
      });
    },
    updateItinerary: (searchRequest) => {
      dispatch({
        type: exchangeAction.SAVEFLIGHTSEARCH,
        newValue: searchRequest,
      });
    },
    updateFlightExtraInfo: (extraInfo) => {
      
      dispatch({
        type: exchangeAction.SAVEFLIGHTEXTRAINFO,
        value: extraInfo,
      });
    },
    updateOriginalPayment: (payment) => {
      dispatch({
        type: exchangeAction.SAVEORIGINALPAYMENT,
        value: payment,
      });
    },
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(Exchange);
